var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiantDollor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8388 11.9205V9.0611H19.4502V15.8218C18.7153 16.5164 17.6486 17.1299 16.25 17.6625C14.8593 18.1873 13.4488 18.4497 12.0186 18.4497C10.2012 18.4497 8.61686 18.0792 7.26566 17.3383C5.91446 16.5897 4.89908 15.5247 4.21952 14.1432C3.53997 12.754 3.2002 11.2452 3.2002 9.61678C3.2002 7.84943 3.57948 6.27888 4.33805 4.90513C5.09662 3.53139 6.20682 2.47792 7.66865 1.74474C8.7828 1.18135 10.1696 0.899658 11.8289 0.899658C13.9861 0.899658 15.6692 1.34342 16.8782 2.23096C18.095 3.11077 18.8773 4.33017 19.225 5.88914L15.7403 6.52585C15.4954 5.69234 15.0331 5.03633 14.3536 4.55784C13.6819 4.07162 12.8404 3.82852 11.8289 3.82852C10.296 3.82852 9.07517 4.30315 8.16646 5.25243C7.26566 6.2017 6.81526 7.61018 6.81526 9.47786C6.81526 11.4922 7.27356 13.0048 8.19017 14.0159C9.10677 15.0192 10.3078 15.5208 11.7934 15.5208C12.5282 15.5208 13.2631 15.3819 13.998 15.104C14.7407 14.8185 15.3768 14.4751 15.9063 14.0737V11.9205H13.8388Z",
    fill: "#0B213E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3501 11.9502L0.600098 11.9502",
    stroke: "#0B213E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3501 8.70019L0.600098 8.70019",
    stroke: "#0B213E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiantDollor);
export default __webpack_public_path__ + "static/media/GiantDollor.cdaa143219c54fa8793b83aea0832021.svg";
export { ForwardRef as ReactComponent };